import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import salaryCutsDetail from "../../../containers/modules/hr/salary-cuts-detail";

export default function SalaryCutsDetailRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="salary-cuts-detail"
      index
      element={
        <AccessControl
          name={"Salary Cuts Detail List"}
          auth={authUser}
          component={salaryCutsDetail}
        />
      }
    ></Route>
  );
}
